<script setup>
    import { ref } from "vue";

    const props = defineProps({
        caseStudies: Object,
        link: String,
        linkLabel: String
    });

    let activeCaseStudy = ref(props.caseStudies[0]);

    function updateActiveCaseStudy(caseStudy) {
        activeCaseStudy = caseStudy;
    }

    function nextCaseStudy() {
        let caseStudyIndex = getCaseStudyIndexByTitle(activeCaseStudy.title);

        if (caseStudyIndex < props.caseStudies.length - 1) {
            activeCaseStudy = props.caseStudies[caseStudyIndex + 1];
        }
    }

    function previousCaseStudy() {
        let caseStudyIndex = getCaseStudyIndexByTitle(activeCaseStudy.title);

        if (caseStudyIndex !== 0) {
            activeCaseStudy = props.caseStudies[caseStudyIndex - 1];
        }
    }

    function getCaseStudyIndexByTitle(title) {
        return props.caseStudies.findIndex(function(caseStudy) {
            return caseStudy.title === title
        });
    }
</script>
<template>
    <div class="block-inner">
        <div class="logo-slider flex flex-wrap">
            <div class="logos flex flex-wrap order-2 md:order-1 mt-4 md:mt-0 w-full md:w-11/12">
                <button
                    v-for="(caseStudy, index) in caseStudies"
                    :key="index"
                    :aria-label="`View the ${caseStudy.title} case study`"
                    type="button"
                    class="logo w-1/6 cursor-pointer flex flex-col justify-between appearance-none"
                    @click="updateActiveCaseStudy(caseStudy)"
                >
                    <img
                        class="max-h-[90px] w-auto object-fit p-4"
                        :src="caseStudy.logo.permalink"
                        :alt="caseStudy.logo?.alt"
                    >
                    <div
                        v-if="caseStudy.title === activeCaseStudy.title"
                        class="w-full h-[6px] bg-[#f89821]"
                        aria-hidden="true"
                    />
                    <div
                        v-if="caseStudy.title !== activeCaseStudy.title"
                        class="w-full h-0.5 bg-black mb-[2px]"
                        aria-hidden="true"
                    />
                </button>
            </div>
            <div class="slide-button order-1 md:order-2 w-full md:w-1/12 flex self-end justify-end md:justify-center">
                <i class="fa-light fa-circle-arrow-left h-[38px] w-[38px] text-[38px] mr-3"
                   :class="{'text-gray-100':caseStudies[0].title === activeCaseStudy.title}" @click="previousCaseStudy()"></i>
                <i class="fa-light fa-circle-arrow-right h-[38px] w-[38px] text-[38px]"
                   :class="{'text-gray-100':caseStudies[caseStudies.length - 1].title === activeCaseStudy.title}" @click="nextCaseStudy()"></i>
            </div>
        </div>
        <div class="case-study-info flex flex-wrap items-center py-10">
            <div class="image w-full lg:w-1/3 pt-4 md:pt-20 pb-14">
                <img :src="activeCaseStudy.logo.permalink" class="m-auto min-h-[300px]" alt="">
                <div class="blur pb-10" style="background: transparent linear-gradient(180deg, #F89821 0%, #FBB117 100%) 0% 0% no-repeat padding-box; opacity: 0.34; filter: blur(47px);"></div>
            </div>
            <div class="text w-full lg:w-2/3 px-0 lg:px-20 pb-0 lg:pb-10">
                <h3 class="text-[#0D0D0D] text-5xl m-auto">{{ activeCaseStudy.title }}</h3>
                <p class="text-[#0D0D0D] py-8 m-0">{{ activeCaseStudy.description }}</p>
                <a class="arrow-button" href="{{ activeCaseStudy.permalink }}">view case study</a>
            </div>
            <div class="button-box w-full text-center pt-20">
                <a href="#" class="theme-button font-medium">View all Case Studies</a>
            </div>
        </div>
    </div>
</template>

